// component name
$component: 'zr-bannerx-slider-control';

@use '../zr-theme/zr-variables.scss' as *;
@use "../zr-css-icon/zr-css-icon.scss" as i;

:host {
    align-items: end;
    display: flex;
}

.#{$component} {
    display: flex;
    gap: 8px;

    button {
        background: #fff;
        border-radius: 25%;
        border: 1px solid #000;
        color: #000;
        cursor: pointer;
        font-size: 0;
        height: 44px;
        outline: none;
        width: 44px;

        &.button-prev {
            @include i.get-icon-left(arrow-left);

            &::before {
                position: relative;
                left: -2px;
            }
        }

        &.button-next {
            @include i.get-icon-left(arrow-right);

            &::before {
                position: relative;
                left: 2px;
            }
        }

        @media only screen and (min-width: $tablet-screen) {
            &:hover,
            &:focus-visible {
                background-color: var(--ci-primary400);
                border-color: #fff;
                color: #fff;

                &::before {
                    background-color: #fff;
                }
            }
        }
    }
}
